// extracted by mini-css-extract-plugin
export default {"input_box":"ImageInput_input_box__L90GN","icon":"ImageInput_icon__Cxn5N","image_box":"ImageInput_image_box__hBfaK","half":"ImageInput_half__mo-5a"};